/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CalendarEventCreateRequest } from '../models/CalendarEventCreateRequest'
import type { CalendarEventCreateResponse } from '../models/CalendarEventCreateResponse'
import type { CalendarEventListResponse } from '../models/CalendarEventListResponse'
import type { CalendarTelemetryClickRequest } from '../models/CalendarTelemetryClickRequest'
import type { CalendarTelemetryDailyRollupResponse } from '../models/CalendarTelemetryDailyRollupResponse'
import type { RotationReminderCreateRequest } from '../models/RotationReminderCreateRequest'
import type { RotationReminderResponse } from '../models/RotationReminderResponse'
import type { CancelablePromise } from '../core/CancelablePromise'
import { OpenAPI } from '../core/OpenAPI'
import { request as __request } from '../core/request'
export class CalendarService {
    /**
     * List Calendar Events
     * @returns CalendarEventListResponse Successful Response
     * @throws ApiError
     */
    public static listCalendarEventsCalendarEventsGet({
        calendarId,
        timeMin,
        timeMax,
        maxResults = 10,
        singleEvents = true,
        subject
    }: {
        calendarId?: string | null
        timeMin?: string | null
        timeMax?: string | null
        maxResults?: number
        singleEvents?: boolean
        subject?: string | null
    }): CancelablePromise<CalendarEventListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/aspen/calendar/events',
            query: {
                calendar_id: calendarId,
                time_min: timeMin,
                time_max: timeMax,
                max_results: maxResults,
                single_events: singleEvents,
                subject: subject
            },
            errors: {
                422: `Validation Error`
            }
        })
    }
    /**
     * Create Calendar Event
     * @returns CalendarEventCreateResponse Successful Response
     * @throws ApiError
     */
    public static createCalendarEventCalendarEventsPost({
        requestBody,
        xCorrelationId,
        xTelemetryCandidateId
    }: {
        requestBody: CalendarEventCreateRequest
        xCorrelationId?: string | null
        xTelemetryCandidateId?: string | null
    }): CancelablePromise<CalendarEventCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/aspen/calendar/events',
            headers: {
                'X-Correlation-Id': xCorrelationId,
                'X-Telemetry-Candidate-Id': xTelemetryCandidateId
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`
            }
        })
    }
    /**
     * Record Calendar Telemetry Click
     * Record one ``click`` telemetry row.
     *
     * Fired by the frontend the instant the Download Calendar button kicks
     * off the Google path. The .ics fallback path does *not* call this.
     * No PII is accepted — only the correlation id and an optional
     * candidate id.
     * @returns string Successful Response
     * @throws ApiError
     */
    public static recordCalendarTelemetryClickCalendarTelemetryClickPost({
        requestBody
    }: {
        requestBody: CalendarTelemetryClickRequest
    }): CancelablePromise<Record<string, string>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/aspen/calendar/telemetry/click',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`
            }
        })
    }
    /**
     * Get Calendar Telemetry Daily
     * Pre-aggregated metrics for the calendar telemetry dashboard.
     *
     * Returns one row per day in the requested window (only days with at
     * least one telemetry row appear). All numbers are scoped to the
     * caller's organization automatically via the ``auth0_organization_isolation``
     * RLS policy on ``aspen.calendar_telemetry``.
     * @returns CalendarTelemetryDailyRollupResponse Successful Response
     * @throws ApiError
     */
    public static getCalendarTelemetryDailyCalendarTelemetryDailyGet({
        startDay,
        endDay
    }: {
        /**
         * Inclusive start date (UTC). Defaults to 30 days ago.
         */
        startDay?: string | null
        /**
         * Exclusive end date (UTC). Defaults to tomorrow (so today is included).
         */
        endDay?: string | null
    }): CancelablePromise<CalendarTelemetryDailyRollupResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/aspen/calendar/telemetry/daily',
            query: {
                start_day: startDay,
                end_day: endDay
            },
            errors: {
                422: `Validation Error`
            }
        })
    }
    /**
     * Delete Calendar Event
     * Delete a Google Calendar event by id.
     *
     * ``send_updates`` controls whether attendees get a cancellation email
     * ("all"/"externalOnly") or not ("none", the Google default).
     * ``subject`` enables domain-wide delegation impersonation.
     * @returns string Successful Response
     * @throws ApiError
     */
    public static deleteCalendarEventCalendarEventsEventIdDelete({
        eventId,
        calendarId,
        sendUpdates = 'none',
        subject
    }: {
        eventId: string
        calendarId?: string | null
        sendUpdates?: 'all' | 'externalOnly' | 'none'
        subject?: string | null
    }): CancelablePromise<Record<string, string>> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/aspen/calendar/events/{event_id}',
            path: {
                event_id: eventId
            },
            query: {
                calendar_id: calendarId,
                send_updates: sendUpdates,
                subject: subject
            },
            errors: {
                422: `Validation Error`
            }
        })
    }
    /**
     * Create the 180-day SA key rotation reminder (idempotent)
     * **No request body is required.** POST with an empty body (or `{}`) to take the canonical defaults — that is the recommended way to call this endpoint.
     *
     * This endpoint is **idempotent**:
     * - If no rotation reminder exists on the configured calendar, a new recurring event is created and returned with `created: true`.
     * - If a rotation reminder already exists (matched via the private `extendedProperties.private.aspenReminder` marker), the existing event is returned with `created: false`. **No duplicate event is created**, so calling this endpoint more than once is always safe.
     *
     * The recurrence is `RRULE:FREQ=DAILY;INTERVAL=180` — Google handles every future occurrence automatically. You only ever need to call POST once per environment.
     *
     * All request body fields are optional overrides:
     * - `firstFireDate` — when the first reminder should fire (default `2026-10-28`).
     * - `fireHour` — local hour-of-day, 0-23 (default `9`).
     * - `durationMinutes` — event length (default `30`).
     * - `timezone` — IANA tz name (default `America/New_York`).
     * - `attendees` — list of emails to invite (default `['tm-app-platform@om1.com']`).
     * - `subject` — Domain-Wide Delegation impersonation target (default `calendar-bot@om1.com`).
     *
     * The destination calendar is server-controlled (sourced from `API_SETTINGS.GOOGLE_CALENDAR_ID`) and **cannot** be passed in the request — the same rule as `POST /calendar/events`.
     * @returns RotationReminderResponse Successful Response
     * @throws ApiError
     */
    public static createRotationReminderEndpointCalendarAdminRotationReminderPost({
        requestBody
    }: {
        requestBody?: RotationReminderCreateRequest
    }): CancelablePromise<RotationReminderResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/aspen/calendar/admin/rotation-reminder',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`
            }
        })
    }
    /**
     * Get Rotation Reminder Endpoint
     * Return the active rotation reminder event, or 404 if none exists.
     * @returns RotationReminderResponse Successful Response
     * @throws ApiError
     */
    public static getRotationReminderEndpointCalendarAdminRotationReminderGet({
        subject
    }: {
        subject?: string | null
    }): CancelablePromise<RotationReminderResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/aspen/calendar/admin/rotation-reminder',
            query: {
                subject: subject
            },
            errors: {
                422: `Validation Error`
            }
        })
    }
    /**
     * Delete Rotation Reminder Endpoint
     * Delete the rotation reminder series.
     *
     * Idempotent: if no reminder is set up, returns ``deleted: false`` with
     * no error. If Google reports the event vanished mid-call (race), the
     * response is still ``deleted: true``.
     * @returns string Successful Response
     * @throws ApiError
     */
    public static deleteRotationReminderEndpointCalendarAdminRotationReminderDelete({
        subject
    }: {
        subject?: string | null
    }): CancelablePromise<Record<string, string>> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/aspen/calendar/admin/rotation-reminder',
            query: {
                subject: subject
            },
            errors: {
                422: `Validation Error`
            }
        })
    }
}
